import React from 'react';
import PropTypes from 'prop-types';
export default class TopDostepnosc extends React.Component {

    render() {
        if (this.props.wartosc==this.props.wartoscWarunek) {
            return <span style={{marginLeft:(this.props.czyMarginesLewy)?'5px':0, fontSize:'10px', color:'forestgreen'}}><i className={'fa fa-check'}></i> {Boolean(this.props.trescSpelniony)?this.props.trescSpelniony:'dostępny'}</span>
        } else {
            return <span style={{marginLeft:(this.props.czyMarginesLewy)?'5px':0, fontSize:'10px', color:'firebrick'}}><i className={'fa fa-times'}></i> {Boolean(this.props.trescNiespelniony)?this.props.trescNiespelniony:'niedostępny'}</span>
        }
    }
}


// wartosc - podajemy testowaną wartość
// wartoscWarunek - podajemy wartość, która powinna być w warunku, do której będzie przyrównywana zmienna w dostepnosc

TopDostepnosc.propTypes = {
    wartoscWarunek: PropTypes.string.isRequired,
    wartosc: PropTypes.string.isRequired,
    czyMarginesLewy: PropTypes.bool,
}


// WEBPACK FOOTER //
// ./src/componentsTopsa/dostepnosc/TopDostepnosc.js